import { All, SortDirection } from "../interfaces";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import * as actions from "../common/actions";
import {
  dataRequested,
  updateFilter,
  updateSortOrder,
} from "../common/actions";
import { dataLoaded } from "../common/actions";
import { receiveResultsFailure } from "../common/actions";
import { StructureChange } from "../components/StructureChange";
import { initialAppState } from "../common/reducers/appState";

export function mapStateToProps({ appState }: All) {
  return {
    appState: appState.structureChange,
  };
}

export function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    onStartRequest: () => {
      dispatch(dataRequested());
    },
    onResultSuccess: () => {
      dispatch(dataLoaded());
    },
    onResultFailure: (error: Error) => dispatch(receiveResultsFailure(error)),
    updateSort: (sortField: string, sortDirection: SortDirection) => {
      dispatch(updateSortOrder(sortField, sortDirection));
    },
    updateFilters: (filter: string, value: number[] | string | undefined) => {
      dispatch(updateFilter(filter, value));
    },
    resetState: () => {
      dispatch(actions.resetState(initialAppState.structureChange));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(StructureChange);
